import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import { authMiddleware } from "@/middlewares";
import scrollBehavior from "./scroll-behavior";
import routes from "./routes";

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

router.beforeEach(authMiddleware);

export default router;
